import { ChangeSocial } from './ChangeSocial';

export class ChangeYoutube extends ChangeSocial {
  type: string = 'ChangeYoutube';
}
